const secialDietsList = [
  { label: "Vegan Options", value: "vegan" },
  { label: "Halal", value: "halal" },
  { label: "Vegetarian friendly", value: "vegetarian" },
  { label: "Gluten free options", value: "gluten_free" },
];

export default secialDietsList;
